import { buvid } from '@/common/log-report';
import { BizEnv, getEnv } from './env';

type Env = 'prod' | 'gray' | 'pre' | 'daily' | 'local';
const env = getEnv();
const envMap: Record<string, Env> = {
  dev: 'local',
  uat: 'daily',
  pre: 'pre',
  prod: 'prod',
  development: 'local',
  production: 'prod',
};


export default class ARMS {
  static __bl: any = null;

  static async init(app: any) {
    if (import.meta.env.SSR) {
      return;
    }
    if (!this.__bl) {
      const BrowserLogger = await import('alife-logger');
      this.__bl = BrowserLogger?.default.singleton({
        pid: '1hfr11220ve@d7fefec18c7dcd2',
        appType: 'web',
        imgUrl: 'https://arms-retcode-sg.aliyuncs.com/r.png?',
        environment: envMap[env],
        // 日志采样配置，值为1~100的整数。对性能日志和成功API日志按照 1/sample 的比例采样
        sample: 100,
        // 关闭 API 调用成功率上报， 会造成播放器销毁不断流
        disableHook: true,
        sendResource: true,
        behavior: true,
        useFmp: true,
        enableLinkTrace: true,
        // 关闭自动上报pv选项， 在路由守卫中上报
        autoSendPv: false,
        // 关闭自动上报性能选项，在路由守卫中上报
        autoSendPerf: false,
        uid: buvid,
        release: __VERSION_CODE__,
        disabled: env !== BizEnv.prod
      });

      app.config.errorHandler = (err: any) => {
        this.__bl && this.__bl.error(err);
      };
    }
    return this.__bl;
  }

  static logSum(key: string, value = 1) {
    return this.__bl && this.__bl.sum(key, value);
  }

  static logAvg(key: string, value = 0) {
    return this.__bl && this.__bl.avg(key, value);
  }

  static logError(name: string, message: string) {
    return this.__bl && this.__bl.error({ name, message });
  }

  /**
   * API 调用成功率上报
   * @param api 接口名
   * @param success 是否调用成功
   * @param time 接口耗时
   * @param code 返回码
   * @param msg 返回信息
   * @param begin API请求开始时间戳
   */
  static logApi(api: string, success: boolean, time: number, code: number | string, msg: string, begin: number) {
    if (this.__bl) {
      this.__bl.api(api, success, time, code, msg, begin);
    }
  }

  static setPage(page: string) {
    // 设置当前页面的page name，并重新上报PV
    return this.__bl && this.__bl.setPage(page);
  }

  static sendPerf(page: string) {
    if (this.__bl) {
      this.__bl._initialPage = page;
      //设置一定的延时，确保默认性能数据采集完成。
      setTimeout(() => this.__bl.performance({}), 1000);
    }
  }

  static setConfig(options: Record<string, any>) {
    return this.__bl && this.__bl.setConfig(options);
  }
}
